// src/constants/appConstants.js (or a more specific name like authConstants.js or storageKeys.js)

// --- Currency & Country (Consider moving to a separate file if app grows) ---
export const CURRENCY_SYMBOLS = {
  US: '$',
  IN: '₹',
  GB: '£',
  EU: '€'
};

export const DEFAULT_CURRENCY_SYMBOL = '₹';

export const AVAILABLE_COUNTRIES = [
  { code: 'US', name: 'United States' },
  { code: 'IN', name: 'India' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'EU', name: 'Euro Zone' }
];

// --- API Configuration ---
export const API = {
  ENDPOINT: '/auth/login',
  FIELD_TYPE: 'type',
  FIELD_USER_TYPE: 'userType',
  FIELD_CODE: 'code',
  FIELD_USER_ID: 'userId',
  FIELD_SCHOOL_CODE: 'schoolCode',
  FIELD_PASSWORD: 'password',
  DEFAULT_TYPE: 'employee',
};

// --- User Interface Text ---
export const UI_TEXT = {
  HEADER: 'Welcome Back',
  SUBTITLE: 'Empowering Smart Schooling!',
  LABEL_SCHOOL_CODE: 'School Code',
  LABEL_USER_TYPE: 'User Type',
  LABEL_USER_ID: 'User ID',
  LABEL_PASSWORD: 'Password',
  BUTTON_SIGN_IN: 'Sign In',
  BUTTON_SIGNING_IN: 'Signing In...',
  LINK_FORGOT_PASSWORD: 'Forgot password?',
  ERROR_MISSING_FIELDS: 'Please fill out all fields.',
  ERROR_LOGIN_FAILED_CREDENTIALS: 'Login failed. Please check credentials.',
  ERROR_SERVER_RESPONSE: 'Login failed. Invalid response from server.',
  ERROR_NETWORK: 'Network error. Please check your connection.',
  ERROR_GENERIC: 'An unexpected error occurred.',
  ERROR_MISSING_SCHOOL_ID: 'School ID is missing in the login response.',
  ARIA_TOGGLE_PASSWORD: 'toggle password visibility',
};

// --- Local Storage Keys ---
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'token',
  USER_TYPE: 'type',
  USER_CODE: 'code',
  USER_ID: 'userId',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  PHONE: 'phone',
  IMAGE_URL: 'imageUrl',
  USER_ROLE: 'role',
  DESIGNATION: 'designation',
  SCHOOL_ID: 'schoolId',
  SCHOOL_NAME: 'schoolName',
  SCHOOL_LOGO: 'schoolLogo',
  SCHOOL_CODE: 'schoolCode',
  SCHOOL_ACADEMIC_YEAR: 'schoolAcademicYear',
  PRINCIPAL_SIGNATURE_URL: 'principalSignatureUrl',
  DIRECTOR_SIGNATURE_URL: 'directorSignatureUrl',
  SCHOOL_SEAL_URL: 'schoolSealUrl',
  SCHOOL_SLOGAN: 'schoolSlogan',
  SCHOOL_ADDRESS: 'schoolAddress',
  SCHOOL_PHONE: 'schoolPhone',
  SCHOOL_EMAIL: 'schoolEmail',
  SCHOOL_AFFILIATION_BOARD: 'schoolAffiliationBoard',
  PAYMENT_DUE_DATE: 'paymentDueDate',
  BILLING_STATUS: 'billingStatus',
  GRACE_DAYS_REMAINING: 'graceDaysRemaining',
  REQUIRES_PAYMENT: 'requiresPayment',
  MESSAGE_CREDIT_BALANCE: 'messageCreditBalance',
  STUDENT_CLASS_ID: 'studentClassId',
  STUDENT_CLASS_NAME: 'studentClassName',
  STUDENT_SECTION_ID: 'studentSectionId',
  STUDENT_SECTION_NAME: 'studentSectionName',
  STUDENT_ACADEMIC_YEAR: 'studentAcademicYear',
};

// --- Navigation Routes ---
export const ROUTES = {
  FORGOT_PASSWORD: '/forgot-password',
  DASHBOARD: '/dashboard',
  SCHOOL_LIST: '/schools/list',
};

// --- Asset URLs ---
export const ASSETS = {
  LOGO_URL: 'https://skhool-media-prod-193482297265.s3.ap-south-1.amazonaws.com/skhool/prod/product/public/images/skhool_logo.png',
  BACKGROUND_URL: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c',
};

// --- General Configuration ---
export const CONFIG = {
  SUCCESS_ANIMATION_DELAY: 2000, 
  SNACKBAR_DURATION: 6000, 
};

// --- User Roles ---
export const ROLES = {
  SCHOOL_ADMIN: 'school_admin', // Use consistent casing (e.g., lowercase as used in component)
  MANAGER: 'manager',
};
